import { Injectable } from '@angular/core';
import { Observable, of, from } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { UtilityFunctionsService } from './utility-functions.service';
import { CardsService } from './cards.service';

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {
  // State properties moved from component
  public feedbackText: string = '';
  public isSubmitting: boolean = false;

  constructor(
    private utilityService: UtilityFunctionsService,
    private cardsService: CardsService
  ) { }

  /**
   * Submits user feedback to the real API endpoint
   * @returns Observable that resolves when submission is complete
   */
  submitFeedback(): Observable<boolean> {
    if (!this.feedbackText.trim() || this.isSubmitting) {
      return of(false);
    }

    this.isSubmitting = true;
    this.utilityService.rollbarInfo(`Feedback submitted, text hidden`, true);
    // Log the feedback for demonstration purposes
    // console.log('Feedback being submitted:', this.feedbackText);
    // this.utilityService.rollbarInfo(`Feedback submitted: ${this.feedbackText}`, true);

    // Use the real API call and map successful response to true
    return from(this.cardsService.sendFeedbackRequest(this.feedbackText, this.getDebugData())).pipe(
      map((response) => {
        console.log('Feedback API response:', response);
        return true; // Always return true on successful API call
      }),
      catchError((error) => {
        console.error('Error submitting feedback:', error);
        this.utilityService.showErrorSnackBar('Failed to send feedback. Please try again.', 3000);
        return of(false);
      }),
      finalize(() => {
        this.isSubmitting = false;
      })
    );
  }

  /**
   * Resets feedback form after submission
   */
  resetFeedback(): void {
    this.feedbackText = '';
    this.isSubmitting = false;
  }

  /**
   * Collects debug information for feedback
   * @returns Debug data string
   */
  private getDebugData(): string {
    const debugInfo = {
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
      url: window.location.href,
      viewport: `${window.innerWidth}x${window.innerHeight}`,
      platform: navigator.platform
    };

    return JSON.stringify(debugInfo);
  }
}
